module.exports = __webpack_public_path__ + "static/media/check-mark-white.661cab6c.svg";